import { render, staticRenderFns } from "./PartnerAd.vue?vue&type=template&id=4551dae0&scoped=true&"
import script from "./PartnerAd.vue?vue&type=script&lang=js&"
export * from "./PartnerAd.vue?vue&type=script&lang=js&"
import style0 from "./PartnerAd.vue?vue&type=style&index=0&id=4551dae0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4551dae0",
  null
  
)

export default component.exports